module.exports = __webpack_public_path__ + "img/bj-screenshot2.82983806.png";